import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowLeft01Icon } from '@hugeicons/core-free-icons';
import { Button } from '@/components/ui/button';
import { SelectionCard } from './SelectionCard';
import { log } from '@/lib/logger';

interface StepAboutYouProps {
  role: string;
  onSelect: (role: string) => void;
  /** Omitted in the invited slim wizard, where the role select is step 1. */
  onBack?: () => void;
  /** Overrides the default heading; the role question moves to a subline. */
  heading?: string;
}

const ROLES = [
  'Designer',
  'Developer',
  'Project Manager',
  'QA Engineer',
  'Founder / CEO',
  'Agency Owner',
];

export function StepAboutYou({ role, onSelect, onBack, heading }: StepAboutYouProps) {
  log.info('[StepAboutYou] render', { role });

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="hero-title">{heading ?? "What's your role?"}</h2>
        {heading && <p className="mt-2 text-gray-500">What's your role?</p>}
      </div>

      <div className="space-y-3">
        {ROLES.map((r) => (
          <SelectionCard
            key={r}
            label={r}
            selected={role === r}
            onClick={() => {
              log.info('[StepAboutYou] role selected', { r });
              onSelect(r);
            }}
          />
        ))}
      </div>

      {onBack && (
        <div className="pt-2">
          <Button
            variant="ghost"
            size="md"
            onClick={() => {
              log.info('[StepAboutYou] back clicked');
              onBack();
            }}
          >
            <span className="flex items-center gap-2">
              <HugeiconsIcon icon={ArrowLeft01Icon} size={16} strokeWidth={2} color="currentColor" className="h-4 w-4" />
              Back
            </span>
          </Button>
        </div>
      )}
    </div>
  );
}
